import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
 * Created on 26. 1. 2021
 *
 * Copyright (c) 2021 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import api from '../../api';
import logger from '../../logger';
import { CONSTANTS } from '../../../constants';
import { Inject } from '@logio/typescript-ioc';
import { List } from 'immutable';
import { jsonConversions, GenericTreeReportHeaderConverter, SalesDashboardComparatorRowDTOConverter } from '@logio/common-be-fe';
/**
 * @author Jakub Gereg
 * @author Tomas Leity
 */

export var SalesDashboardCompLayer =
/*#__PURE__*/
function () {
  function SalesDashboardCompLayer() {
    _classCallCheck(this, SalesDashboardCompLayer);
  }

  _createClass(SalesDashboardCompLayer, [{
    key: "findOrCreateReport",

    /**
     * <p>
     *  Finds / generates report based on provided parameters.
     *  Returns report status {@link GenericTreeReportHeader} with report id.
     * </p>
     *
     * @param params {@link ISalesDashboardComparatorItemParams} params
     */
    value: function findOrCreateReport(params) {
      var _this = this;

      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.SALES_DASHBOARD_COMP_REPORT_FIND).post(Object.assign({}, params), apiConfig).then(function (response) {
        return _this.genericTreeReportHeaderConverter.toObject(response.data.result, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * <p>
     *  Generates new report based on provided parameters.
     *  Returns report status {@link GenericTreeReportHeader} with report id.
     * </p>
     *
     * @param params {@link ISalesDashboardComparatorItemParams} params
     */

  }, {
    key: "generateReport",
    value: function generateReport(params) {
      var _this2 = this;

      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.SALES_DASHBOARD_COMP_REPORT_GENERATE).post(Object.assign({}, params), apiConfig).then(function (response) {
        return _this2.genericTreeReportHeaderConverter.toObject(response.data.result, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * <p>
     *  Gets generated report rows based on provided reportId.
     *  Returns list of {@link SalesDashboardComparatorRowDTO} rows.
     * </p>
     *
     * @param reportId Provided specific report id.
     */

  }, {
    key: "getReportRows",
    value: function getReportRows(reportId) {
      var _this3 = this;

      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.SALES_DASHBOARD_COMP_REPORT_ROWS(reportId)).get(apiConfig).then(function (response) {
        return List((response.data.result || []).map(function (item) {
          return _this3.sdComparatorRowDTOConverter.toObject(item, jsonConversions);
        }));
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * <p>
     *  Checks report status based on provided reportId.
     *  Returns report status {@link GenericTreeReportHeader} with report id.
     * </p>
     *
     * @param reportId Provided specific report id.
     */

  }, {
    key: "getReportStatus",
    value: function getReportStatus(reportId) {
      var _this4 = this;

      var apiConfig = {
        responseType: 'json'
      };
      return api(CONSTANTS.API.ENDPOINTS.SALES_DASHBOARD_COMP_REPORT_STATUS(reportId)).get(apiConfig).then(function (response) {
        return _this4.genericTreeReportHeaderConverter.toObject(response.data.result, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return SalesDashboardCompLayer;
}();

__decorate([Inject, __metadata("design:type", GenericTreeReportHeaderConverter)], SalesDashboardCompLayer.prototype, "genericTreeReportHeaderConverter", void 0);

__decorate([Inject, __metadata("design:type", SalesDashboardComparatorRowDTOConverter)], SalesDashboardCompLayer.prototype, "sdComparatorRowDTOConverter", void 0);